import React from "react";

export const GlobalStateContext = React.createContext();
export const GlobalDispatchContext = React.createContext();

const initialState = {
    visible : false,
}

function visibilityComponent (state, action) {
    switch(action.type) {
        case "TOGGLE_VISIBILITY": {
            return {
                ...state,
                visible: state.visible === false ? true : false,
            }
        }
        default:
            throw new Error ("Bad action type");
    }
}

 const GlobalContextProvider = ({children}) => {
    const [state, dispatch] = React.useReducer(visibilityComponent, initialState);
    return (
        <GlobalStateContext.Provider value={state}>
            <GlobalDispatchContext.Provider value={dispatch}>
                {children}
            </GlobalDispatchContext.Provider>
        </GlobalStateContext.Provider>
    )
}

export default GlobalContextProvider;